import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';
import { withCancelToken } from '../../../queries/helpers/withCancelToken';

const fetcher = async (params, source) => {
  return request.get(
    '/FlatsGrid/available_stage_address_life_cycle_by_address_id',
    params,
    undefined,
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token },
    true
  );
};

const cancelableFetcher = (params) => {
  return withCancelToken((source) => fetcher(params, source));
};

const useRoomStages = ({ addressId } = {}, options) => {
  return useQuery(
    getQueryKeys.roomStages(addressId),
    () => cancelableFetcher({ addressId }),
    {
      enabled: Boolean(addressId),
      notifyOnChangeProps: 'tracked',
      ...options,
    }
  );
};

export { useRoomStages };
